import { useContext } from 'react';

import { FormEditPageContext } from '@/components/form-edit-page-provider';

function useFormEditPage() {
	const context = useContext(FormEditPageContext);

	return context;
}

export default useFormEditPage;
